export function classNames(...classes: (string | undefined | boolean | null | {})[]) {
  return classes
    .filter((c) => !!c)
    .flatMap((c) =>
      typeof c === 'object' && c
        ? Object.entries(c)
            .filter(([k, v]) => !!v)
            .map(([k]) => k)
        : [c]
    )
    .join(' ');
}

export function mergeClasses<T extends object, U extends object>(one: T, two: U): T & U {
  return {
    ...one,
    ...two,
    ...Object.keys(two)
      .filter((k) => !!(one as any)[k])
      .map((k) => [k, classNames((one as any)[k], (two as any)[k])])
      .reduce((a, [k, v]) => ({ ...a, [k]: v }), {}),
  };
}
